import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useCallback,
} from "react";
import { useNavigate } from "react-router-dom";
import { empty_uuid, ftchPlus, FtchPlusError, getOptions, SetupAccountsUrl_get } from "../App/Account_urls.jsx";
import { Container, Stack } from "@mui/material";
import { AccordianGrid, AccordionSet } from "../Components/AccordianGrid.jsx";
import { EditIconRenderer } from "../App/GridRenderers.jsx";
import AddGov from "../Dialogs/Accounts/AddGov.jsx";
import AddSimpleAccount from "../Dialogs/Accounts/AddSimpleAccount.jsx";
import AddInvestAccount from "../Dialogs/Accounts/AddInvestAccount.jsx";
import AddInvestLoanAccount from "../Dialogs/Accounts/AddInvestLoanAccount.jsx";
import AddDBPensionAccount from "../Dialogs/Accounts/AddDBPensionAccount.jsx";
import AddPropertyAccount from "../Dialogs/Accounts/AddPropertyAccount.jsx";
import AddLiabilityAccount from "../Dialogs/Accounts/AddLiabilityAccount.jsx";
import AddAnnuityAccount from "../Dialogs/Accounts/AddAnnuityAccount.jsx";



import {
  moneyFormatter,
  percentFormatter,
  percent0Formatter,
  upToAgeFormatter,
} from "../App/GridFormatters.jsx";
import { CrumbToggleScenario } from "../Components/CrumbToggles.jsx";

import { ErrorBar } from "../Components/ErrorBar.jsx";
import { Help_setupAccounts } from "../Dialogs/Help/Help_Setup.jsx";
import { QuickUpdateIcon } from "../Components/QuickIcon.jsx";
import { QuickUpdate } from "../Dialogs/Accounts/QuickUpdate.jsx";

const SetupAccordianGrids = ({ clientJson, c_callback }) => {
  const navigate = useNavigate();
  const clientData = useRef;
  const [errmsg, setErrmsg] = useState("")

  const [clients, setClients] = useState([""]);
  const [client, setClient] = useState("");
  const [refetch, setRefetch] = useState(0)
  const [employment, setEmployment] = useState();
  const [expenses, setExpenses] = useState();
  const [nonregistered, setNonregistered] = useState();
  const [investLoan, setInvestLoan] = useState();
  const [registered, setRegistered] = useState();
  const [pension, setPension] = useState();
  const [annuity, setAnnuity] = useState();
  const [retirement, setRetirement] = useState();
  const [property, setProperty] = useState();
  const [liability, setLiability] = useState();
  const [inheritance, setInheritance] = useState();
  const [government, setGovernment] = useState();
  const [quickUpdateShow, setQuickUpdateShow] = useState(false)
  const [openAccordion, setOpenAccordion] = useState("0")


  const [show, setShow] = useState(
    { Employment: false },
    { Gov: false },
    { Expenses: false },
    { Inheritance: false },
    { NonRegistered: false },
    { InvestLoan: false },
    { Registered: false },
    { Retirement: false },
    { DBPension: false },
    { Property: false },
    { Liability: false },
    { Annuity: false },
  );
  const [add, setAdd] = useState(
    { Employment: false },
    { Expenses: false },
    { Inheritance: false },
    { NonRegistered: false },
    { InvestLoan: false },
    { Registered: false },
    { Retirement: false },
    { DBPension: false },
    { Property: false },
    { Liability: false },
    { Annuity: false },
  );
  const [noNewAccounts, setNoNewAccounts] = useState(false)
  const [addDataDisabled, setAddDataDisabled] = useState(false)

  const [account, setAccount] = useState();
  const [accountUuid, setAccountUuid] = useState();

  const icon = useRef();

  // consuming Grid Event
  const cellClickedListener = useCallback((event) => {
    console.log("cellClicked", event);
  }, []);












  //   const percentFormatter = (params) => {
  //     if (params.value!==null) {
  //       return params.value.toFixed(2) + "%";
  //     }
  //   };


  const cd_Name = {
    headerName: "Name",
    field: "FullName",
    width: 240,
    sort: "asc",
    sortIndex: 0,
    filter: "agTextColumnFilter",
  };

  const cd_Year = {
    headerName: "Year",
    field: "Year",
    sort: "asc",
    sortIndex: 1,
    type: "rightAligned",
  };

  const cd_Value = {
    headerName: "Value",
    field: "Value",
    type: "rightAligned",
    valueFormatter: moneyFormatter,
    width: 140,
  };
  const cd_CostBasis = {
    headerName: "Cost",
    field: "CostBasis",
    type: "rightAligned",
    valueFormatter: moneyFormatter,
    width: 140,
  };
  const cd_SpousePercent = {
    headerName: "Spouse %",
    field: "SpousePercentage",
    type: "rightAligned",
    width: 110,
    valueFormatter: percent0Formatter,
  };

  const cd_ReturnType = {
    headerName: "ReturnType",
    field: "ReturnType",
  };
  const cd_ReturnRate = {
    headerName: "Rate",
    field: "ReturnRate",
    type: "rightAligned",
    valueFormatter: percentFormatter,
    width: 140,
  };
  const cd_Rate = {
    headerName: "Rate",
    field: "IncomeRate",
    type: "rightAligned",
    valueFormatter: percentFormatter,
  };
  const cd_IncomeRate = {
    headerName: "Income",
    field: "IncomeRate",
    type: "rightAligned",
    valueFormatter: percentFormatter,
  };
  const cd_TaxFreeRate = {
    headerName: "Return %",
    field: "TaxFree",
    type: "rightAligned",
    valueFormatter: percentFormatter,
  };
  const cd_DividendRate = {
    headerName: "Dividend",
    field: "DividendRate",
    type: "rightAligned",
    valueFormatter: percentFormatter,
  };
  const cd_CapitalGainRate = {
    headerName: "Cap Gain",
    field: "CapitalGainRate",
    type: "rightAligned",
    valueFormatter: percentFormatter,
  };
  const cd_UnrealizedCapitalGainRate = {
    headerName: "UnR CG",
    field: "UnrealizedCapitalGainRate",
    type: "rightAligned",
    valueFormatter: percentFormatter,
  };
  const cd_InterestRate = {
    headerName: "Interest",
    field: "InterestRate",
    type: "rightAligned",
    valueFormatter: percentFormatter,
  };

  const cd_ReturnOfCapitalRate = {
    headerName: "ROC",
    field: "ReturnOfCapitalRate",
    type: "rightAligned",
    valueFormatter: percentFormatter,
  };
  const cd_UnreValue = {
    headerName: "ReturnValue",
    field: "ReturnValue",
  };
  const cd_MoreReturns = {
    headerName: "MoreReturns",
    field: "MoreReturns",
    cellStyle: { placeItems: "center" },
  };

  const cd_Payment = {
    headerName: "Value",
    field: "Payment",
    type: "rightAligned",
    valueFormatter: moneyFormatter,
    width: 140,
  };
  const cd_PaymentType = {
    headerName: "Type",
    field: "PaymentType",
    width: 140,
  };

  const cd_UpToAge = {
    headerName: "UpToAge",
    field: "UpToAge",
    type: "rightAligned",
    valueFormatter: upToAgeFormatter,
  };

  const cd_EoL = {
    headerName: "EoL %",
    field: "EoL",
    type: "rightAligned",
  };


  const cd_LiabilityAccount = {
    headerName: "Liability",
    field: "LiabilityAccount",
    width: 240,
  };



  const cd_Edit = {
    headerName: "Edit",
    field: "Editable",
    cellRenderer: EditIconRenderer,
    cellRendererParams: {
      callback: (e) => { icon.current = e },
    }
  };

  const cd_Annual = {
    headerName: "Annual Value",
    field: "Annual",
    type: "rightAligned",
    valueFormatter: moneyFormatter,
    width: 140,
  };
  const cd_GuaranteeYears = {
    headerName: "Guar Years",
    field: "GuaranteeYears",
    width: 120,
    type: "rightAligned",
  };
  const cd_StartAge = {
    headerName: "Start Age",
    field: "StartAge",
    type: "rightAligned",
  };
  const cd_StartAgeMonth = {
    headerName: "Start Month",
    field: "StartMonth",
    width: 120,
    type: "rightAligned",
  };
  const cd_PensionAdjustment = {
    headerName: "PensionAdjustment",
    field: "PensionAdjustment",
    type: "rightAligned",
    valueFormatter: moneyFormatter,
    width: 140,
  };
  const cd_Bridge = {
    headerName: "Annual Value",
    field: "Bridge",
    type: "rightAligned",
    valueFormatter: moneyFormatter,
    width: 140,
  };
  const cd_BridgeStartAge = {
    headerName: "Start Age",
    field: "BridgeStartAge",
  };
  const cd_BridgeEndAge = {
    headerName: "UpToAge",
    field: "BridgeEndAge",
  };
  const cd_SurvivorPercent = {
    headerName: "Survivor %",
    field: "SurvivorPercent",
    type: "rightAligned",
    valueFormatter: percent0Formatter,
    width: 110,
  };
  const cd_EmploymentAccount = {
    headerName: "Employment Account",
    field: "EmploymentAccount",
    width: 240,
  };

  const cd_CPPStartAge = {
    headerName: "Start Age",
    field: "Cpp.StartAge",
    type: "rightAligned",
  };
  const cd_CPPDetail = {
    headerName: "Detail",
    field: "Cpp.DetailEntry",
    cellStyle: { placeItems: "center" },
  };
  const cd_CPPPercent = {
    headerName: "Percent of Max",
    field: "Cpp.Percent",
    type: "rightAligned",
    valueFormatter: percent0Formatter,
  };
  const cd_CPPSurvivor = {
    headerName: "SurvivorAmount",
    field: "Cpp.SurvivorAmount",
    type: "rightAligned",
    valueFormatter: moneyFormatter,
    width: 140,
  };
  const cd_CPPPersonal = {
    headerName: "PersonalAmount",
    field: "Cpp.PersonalAmount",
    type: "rightAligned",
    valueFormatter: moneyFormatter,
    width: 140,
  };

  const cd_OASStartAge = {
    headerName: "Start Age",
    field: "Oas.StartAge",
    type: "rightAligned",
  };
  const cd_ResidentMax = {
    headerName: "Max",
    field: "Oas.ResidentMax",
    cellStyle: { placeItems: "center" },
  };
  const cd_ResidentYears = {
    headerName: "Years",
    field: "Oas.ResidentYears",
    type: "rightAligned",
  };
  const cd_NonResident = {
    headerName: "NonResident",
    field: "Oas.NonResident",
    cellStyle: { placeItems: "center" },
  };

  const cd_AnnuityType = {
    headerName: "Type",
    field: "AnnuityType",
    width: 120,
  };
  const cd_RegisteredAnn = {
    headerName: "Registered",
    field: "Registered",
  };
  const cd_PurchaseYear = {
    headerName: "Year",
    field: "PurchaseYear",
    type: "rightAligned",
  };
  const cd_Purchase = {
    headerName: "Amount",
    field: "Purchase",
    type: "rightAligned",
    valueFormatter: moneyFormatter,
    width: 140,
  };
  const cd_PaymentStartYear = {
    headerName: "Start",
    field: "PaymentStartYear",
    type: "rightAligned",
  };
  const cd_PaymentEndYear = {
    headerName: "End",
    field: "PaymentEndYear",
    type: "rightAligned",
  };
  const cd_PaymentAnn = {
    headerName: "Value",
    field: "Payment",
    type: "rightAligned",
    valueFormatter: moneyFormatter,
    width: 140,
  };
  const cd_PaymentPercent = {
    headerName: "%",
    field: "PaymentPercent",
    type: "rightAligned",
    valueFormatter: percent0Formatter,
  };
  const cd_PurchaseAccount = {
    headerName: "Account",
    field: "PurchaseAccount",
    width: 240,
  };
  const cd_PurchasePercent = {
    headerName: "% of Account",
    field: "PurchasePercent",
    type: "rightAligned",
    width: 130,
    valueFormatter: percent0Formatter,
  };
  const cd_Annuitants = {
    headerName: "Annuitants",
    field: "Annuitants",
    width: 240,
  };

  const cd_Employment = [cd_Edit, cd_Name, cd_Year, cd_Value, cd_UpToAge];

  const cd_Expenses = [
    cd_Edit,
    cd_Name,
    cd_Year,
    cd_Value,
    cd_SpousePercent,
    cd_UpToAge,
    cd_EoL,
  ];
  const cd_NonRegistered = [
    cd_Edit,
    cd_Name,
    cd_Year,
    cd_Value,
    cd_CostBasis,
    cd_IncomeRate,
    cd_DividendRate,
    cd_CapitalGainRate,
    cd_UnrealizedCapitalGainRate,
    cd_ReturnOfCapitalRate,
    cd_MoreReturns,
  ];
  const cd_Registered = [cd_Edit, cd_Name, cd_Year, cd_Value, cd_TaxFreeRate];

  const cd_Retirement = [cd_Edit, cd_Name, cd_Year, cd_Value, cd_TaxFreeRate];
  const cd_Inheritance = [
    cd_Edit,
    cd_Name,
    cd_Year,
    cd_Value,
    cd_SpousePercent,
    cd_UpToAge,
  ];

  const cd_Property = [
    cd_Edit,
    cd_Name,
    cd_Year,
    cd_Value,
    cd_SpousePercent,
    cd_CostBasis,
    cd_LiabilityAccount,
  ];

  const modColumns = (colDef) => {
    if (clientJson.readonly || clientJson.Scenario.readonly) {
      return colDef;
    }
    //colDef.push(cd_Delete);
    return colDef;
  };

  const cd_Liability = [
    cd_Edit,
    {
      headerName: "",
      children: [cd_Name, cd_Year, cd_Value, cd_SpousePercent, cd_InterestRate],
    },
    {
      headerName: "Payment",
      children: [cd_Payment, cd_PaymentType],
    },
  ];

  const cd_InvestLoan = [
    cd_Edit,
    {
      headerName: "",
      children: [cd_Name, cd_Year, cd_Value, cd_SpousePercent, cd_Rate],
    },
    {
      headerName: "Payment",
      children: [cd_Payment, cd_PaymentType],
    },
  ];

  const cd_Pensions = [
    cd_Edit,
    cd_Name,
    {
      headerName: "Basic",
      children: [
        cd_Annual,
        cd_StartAge,
        cd_StartAgeMonth,
        //cd_GuaranteeYears,
        cd_PensionAdjustment,
        cd_SurvivorPercent,
        //cd_EmploymentAccount,
      ],
    },
    {
      headerName: "Bridge",
      children: [cd_Bridge, cd_BridgeEndAge],
    },
  ];


  const cd_Annuity = [
    cd_Edit,
    cd_Name,
    cd_AnnuityType,
    cd_Annuitants,
    {
      headerName: "Payment",
      children: [cd_PaymentStartYear, cd_PaymentEndYear, cd_PaymentAnn, cd_PaymentPercent, cd_GuaranteeYears],
    },
    {
      headerName: "Purchase",
      children: [
        cd_PurchaseYear,
        cd_PurchaseAccount,
        cd_Purchase,
        cd_PurchasePercent,
      ],

    },
  ];
  const cd_Government = [
    cd_Edit,
    {
      headerName: "CPP/QPP",
      children: [cd_CPPStartAge, cd_CPPDetail, cd_CPPPercent, cd_CPPPersonal, cd_CPPSurvivor],
    },
    {
      headerName: "OAS",
      children: [
        cd_OASStartAge,
        {
          headerName: "Canadian Residency",
          children: [cd_ResidentMax, cd_ResidentYears, cd_NonResident],
        },
      ],
    },
  ];

  const NonNullArray = (v) => {
    return v ? v : []
  }

  const Update = (cl) => {
    console.log("Set Client: " + cl);
    setClient(cl);
    setNoNewAccounts(clientData.current[cl].NoNewAccounts);
    setEmployment(NonNullArray(clientData.current[cl].Employment));
    setExpenses(NonNullArray(clientData.current[cl].Expenses));
    setNonregistered(NonNullArray(clientData.current[cl].NonRegistered));
    setInvestLoan(NonNullArray(clientData.current[cl].InvestLoan));
    setRegistered(NonNullArray(clientData.current[cl].Registered));
    setRetirement(NonNullArray(clientData.current[cl].Retirement));
    setProperty(NonNullArray(clientData.current[cl].Property));
    setLiability(NonNullArray(clientData.current[cl].Liability));
    setInheritance(NonNullArray(clientData.current[cl].Inheritance));
    setPension(NonNullArray(clientData.current[cl].Pension));
    setAnnuity(NonNullArray(clientData.current[cl].Annuity));
    setGovernment(NonNullArray(clientData.current[cl].Government));
  };

  const onGovGridClicked = () => { };

  const getData = async () => {
    console.log(clientJson);
    if (clientJson && clientJson.uuid) {
      let url = SetupAccountsUrl_get(clientJson, null, "");
      ftchPlus(url, getOptions)
        .then((json) => {
          if (json) {
            console.log(json);
            clientData.current = json.ClientData;
            setClients(json.Clients);
            setAddDataDisabled(json.Entitlement.AddDataDisabled)
            if (client === "") {
              Update(json.Clients[0]);
            } else {
              Update(client);
            }
          } else {
            console.log("no such data");
          }
        })
        .catch((error) => {
          console.log(error.message);
          setErrmsg(error.message)
          FtchPlusError(error)
        });
    }
  };

  const onClientChange = (e) => {
    console.log(e);
    Update(e);
  };

  const DoDelete = (e) => {
    console.log("DoDelete");
  };

  const cellClickSimpleAccount = (accountType, e) => {
    let acc = e.data.FullName;
    let acc_uuid = empty_uuid
    if (e.data.Uuid !== empty_uuid) {
      acc_uuid = e.data.Uuid
    }
    console.log(icon)
    console.log(acc)
    console.log(acc_uuid)
    setAccount(acc);
    setAccountUuid(acc_uuid)
    if (e.colDef.headerName === "Edit" || e.colDef.headerName === "Delete") {
      switch (icon.current) {
        case "go-edit": {
          setShow({ ...show, [accountType]: true });
          break;
        }

        case "go-delete": {
          DoDelete(e);
          break;
        }
      }
    }
  };

  const cellClickGovernment = (accountType, e) => {
    if (e.colDef.headerName === "Edit") {
      switch (icon.current) {
        case "go-edit": {
          setShow({ ...show, [accountType]: true });
          break;
        }
      }
    }
  };

  const myClose = (acc) => {
    setShow({ ...show, [acc]: false });
    setAdd({ ...add, [acc]: false });
    setRefetch(refetch + 1)
  };
  const my_addClick = (acc, e) => {
    setAccount(acc);
    console.log(acc);
    setAdd({ ...add, [acc]: true });
    setShow({ ...show, [acc]: true });
  };

  // load data from sever
  // useEffect(() => {
  //   setErrmsg("")
  //   console.log("get init data")
  //   getData();
  // }, [clientJson]);

  useEffect(() => {
    setErrmsg("")
    console.log("refetch Data " + refetch)
    getData();
  }, [refetch])

  useEffect(() => { }, [client]);

  const handleQuickClose = (json) => {
    setQuickUpdateShow(false);
    setRefetch(refetch + 1)


  }

  const myAccordionOpen = (key, state) => {
    if (state) {
      setOpenAccordion(key)
    } else {
      setOpenAccordion("")
    }
  }

  const My_AccordianGrid = ({ columnDef, type = "accounts", ...otherProps }) => {
    return (
      <AccordianGrid
        type={type}
        columnDef={modColumns(columnDef)}
        addClick={my_addClick}
        cellClickedListener={cellClickSimpleAccount}
        onClick_kb={myAccordionOpen}
        openKey={openAccordion}
        {...otherProps}
      />
    )
  }

  console.log(quickUpdateShow)

  return (
    <div style={{ display: "flex" }}>
      <Container maxWidth="true">
        <Stack spacing={2}>
          <Stack direction="row" spacing={2} sx={{ alignContent: "center" }}>

            <Stack direction="row" spacing={2}>
              <CrumbToggleScenario
                set={clients}
                current={client}
                clientJson={clientJson}
                onChange={onClientChange}
                crumbClose={c_callback}
              />
            </Stack>

            {/* <Box
              sx={{
              display:"flex",
              flexGrow: 1,
              alignContent:"center",
              justifyContent"flex-end",
              }}
            > */}
            <QuickUpdateIcon
              onClick={() => { setQuickUpdateShow(true) }}
            />
            {/* </Box> */}
          </Stack>

          <AccordionSet>
            <My_AccordianGrid
              eventKey="0"
              name="Employment"
              accountType="Employment"
              columnDef={cd_Employment}
              data={employment}
              add={!(noNewAccounts || addDataDisabled)}
            />
            <My_AccordianGrid
              eventKey="1"
              name="Expenses - Expenses, Carrying Costs"
              accountType="Expenses"
              columnDef={cd_Expenses}
              data={expenses}
              add={!(noNewAccounts || addDataDisabled)}
            />
            <My_AccordianGrid
              eventKey="2"
              name="Investments NonRegistered - Cash, Stocks, ..."
              accountType="NonRegistered"
              columnDef={cd_NonRegistered}
              data={nonregistered}
              add={!(noNewAccounts || addDataDisabled)}
            />
            <My_AccordianGrid
              eventKey="2.1"
              name="Investments NonRegistered - Loans made to others, "
              accountType="InvestLoan"
              columnDef={modColumns(cd_InvestLoan)}
              data={investLoan}
              add={!(noNewAccounts || addDataDisabled)}
            />
            <My_AccordianGrid
              eventKey="3"
              name="Investments Registered - TFSA, TFFHSA, RESP, ..."
              accountType="Registered"
              columnDef={modColumns(cd_Registered)}
              data={registered}
              add={!(noNewAccounts || addDataDisabled)}
            />
            <My_AccordianGrid
              eventKey="4"
              name="Investments Retirement - RRSP/RRIF, DCPP/LIRA/LIF, ..."
              accountType="Retirement"
              columnDef={modColumns(cd_Retirement)}
              data={retirement}
              add={!(noNewAccounts || addDataDisabled)}
            />
            <My_AccordianGrid
              eventKey="5"
              name="Defined Benefit Pensions"
              accountType="DBPension"
              columnDef={modColumns(cd_Pensions)}
              data={pension}
              add={!(noNewAccounts || addDataDisabled)}
            />
            <My_AccordianGrid
              eventKey="10"
              name="Annuity"
              accountType="Annuity"
              columnDef={modColumns(cd_Annuity)}
              data={annuity}
              add={!(noNewAccounts || addDataDisabled)}
            />
            <My_AccordianGrid
              eventKey="6"
              name="Property - Principal Residence, Seasonal, Income Property, Builds, ..."
              type="accounts"
              accountType="Property"
              columnDef={modColumns(cd_Property)}
              data={property}
              add={!(noNewAccounts || addDataDisabled)}
            />
            <My_AccordianGrid
              eventKey="7"
              name="Liability- Loans, Mortgages, LOC, ... "
              type="accounts"
              accountType="Liability"
              columnDef={modColumns(cd_Liability)}
              data={liability}
              add={!(noNewAccounts || addDataDisabled)}
            />
            <My_AccordianGrid
              eventKey="8"
              name="Inheritance - Gifts, ..."
              type="accounts"
              accountType="Inheritance"
              columnDef={modColumns(cd_Inheritance)}
              data={inheritance}
              add={!(noNewAccounts || addDataDisabled)}
            />
            <My_AccordianGrid
              eventKey="9"
              name="Government - CPP/QPP, OAS, GIS, Credits, Tax"
              type="data"
              accountType="Gov"
              columnDef={cd_Government}
              data={government}
            />
          </AccordionSet>
          <AddSimpleAccount
            show={show.Employment}
            add={add.Employment}
            account={account}
            account_uuid={accountUuid}
            accountType="Employment"
            doRepeat={true}
            close={myClose}
            client={client}
            client_p={client}
            clientJson={clientJson}
            c_callback={c_callback}
          />
          <AddSimpleAccount
            show={show.Expenses}
            add={add.Expenses}
            account={account}
            account_uuid={accountUuid}
            accountType="Expenses"
            doRepeat={true}
            doReduceEoL={true}
            doTaxTreatment={true}
            doFrom={true}
            close={myClose}
            dosp={true}
            client_p={client}
            clientJson={clientJson}
            c_callback={c_callback}
          />
          <AddInvestAccount
            show={show.NonRegistered}
            add={add.NonRegistered}
            account={account}
            account_uuid={accountUuid}
            accountType="NonRegistered"
            close={myClose}
            client_p={client}
            clientJson={clientJson}
            c_callback={c_callback}
          />
          <AddInvestLoanAccount
            show={show.InvestLoan}
            add={add.InvestLoan}
            account={account}
            account_uuid={accountUuid}
            accountType="InvestLoan"
            close={myClose}
            client_p={client}
            clientJson={clientJson}
            c_callback={c_callback}
            dosp={true}
          />
          <AddInvestAccount
            show={show.Registered}
            add={add.Registered}
            account={account}
            account_uuid={accountUuid}
            accountType="Registered"
            close={myClose}
            client_p={client}
            clientJson={clientJson}
            c_callback={c_callback}
            oneRate={true}
          />
          <AddInvestAccount
            show={show.Retirement}
            add={add.Retirement}
            account={account}
            account_uuid={accountUuid}
            accountType="Retirement"
            close={myClose}
            client_p={client}
            clientJson={clientJson}
            c_callback={c_callback}
            oneRate={true}

          />
          <AddDBPensionAccount
            show={show.DBPension}
            add={add.DBPension}
            account={account}
            account_uuid={accountUuid}
            accountType="DBPension"
            close={myClose}
            client_p={client}
            clientJson={clientJson}
            c_callback={c_callback}
          />
          <AddAnnuityAccount
            show={show.Annuity}
            add={add.Annuity}
            account={account}
            account_uuid={accountUuid}
            accountType="Annuity"
            close={myClose}
            client_p={client}
            clientJson={clientJson}
            c_callback={c_callback}
          />
          <AddPropertyAccount
            show={show.Property}
            add={add.Property}
            account={account}
            account_uuid={accountUuid}
            accountType="Property"
            close={myClose}
            dosp={true}
            client_p={client}
            clientJson={clientJson}
            c_callback={c_callback}
          />
          <AddLiabilityAccount
            show={show.Liability}
            add={add.Liability}
            account={account}
            account_uuid={accountUuid}
            accountType="Liability"
            close={myClose}
            dosp={true}
            client_p={client}
            clientJson={clientJson}
            c_callback={c_callback}
          />

          <AddSimpleAccount
            show={show.Inheritance}
            add={add.Inheritance}
            account={account}
            account_uuid={accountUuid}
            accountType="Inheritance"
            doRepeat={true}
            close={myClose}
            dosp={true}
            client_p={client}
            clientJson={clientJson}
            c_callback={c_callback}
          />
          <AddGov
            show={show.Gov}
            accountType="Gov"
            close={myClose}
            client_p={client}
            clientJson={clientJson}
            c_callback={c_callback}
          />
          <QuickUpdate
            open={quickUpdateShow}
            onClose={handleQuickClose}
            clientJson={clientJson}
          />
        </Stack>
        <ErrorBar error={errmsg} />
        <Help_setupAccounts />
      </Container>
    </div >
  );
};

export default SetupAccordianGrids;
